var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.crumbs),function(item,i){return _c('li',{key:i,class:item.classes},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }